<template>
  <div :id="id">
    <slot /> <!-- Slot por defecto -->
    <slot v-if="$slots.footer" name="footer" />
  </div>
</template>

<script>
export default {
  name: 'CustomCollapse',
  meta: {
    description: 'Componente padre del CustomCollapseItem',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
      footer: {
        type: 'component',
        description: 'Contenido del pie del CustomCollapse (botones, acciones, etc.)',
      },
    },
  },
  props: {
    id: {
      type: String,
      required: true,
      default: 'idCustomCollapse',
      meta: {
        description: 'Id contenedor para los CustomCollapse',
        example: 'idCustomCollapse',
      },
    },
  },
};
</script>